// extracted by mini-css-extract-plugin
module.exports = {"dialog":"dialog__1sj8P"};